import React from "react";
import { GiftIcon } from "lucide-react";
import { bonuses } from "../data/content";
import { surface } from "../data/theme";
import { Reveal } from "./Reveal";
import { Section } from "./Section";
import { SectionTitle } from "./SectionTitle";
import { VerbChips } from "./VerbChips";
export function Bonuses() {
  return <Section labelledBy="bonuses-title" className="bg-violet" waveTo={surface.white} data-id="element-17" data-mp="ft4r9kolfgfs">
      <Reveal data-id="element-18" data-mp="1u59mwzi01t4">
        <SectionTitle id="bonuses-title" tone="dark" title={bonuses.title} highlight={bonuses.highlight} after={bonuses.after} className="text-center" data-id="element-19" data-mp="1tlutp559tjb" />
      </Reveal>
      <ul className="mt-10 space-y-4" data-id="element-20" data-mp="3o24w6539q3vw">
        {bonuses.items.map((item, i) => <Reveal as="li" key={item.title} delay={i * 0.04} className="relative rounded-2xl border border-gold/45 bg-white/[0.07] p-5 shadow-[0_12px_30px_-18px_rgba(0,0,0,0.5)] sm:p-6" data-id="element-21" data-mp="3o3y6pvh05896" data-mpi={i}>
            <div className="flex items-center justify-between gap-3" data-id="element-22" data-mp="1m85mfo5snulb">
              <div className="flex flex-wrap items-center gap-2" data-id="element-23" data-mp="1r80fnyd1kw9j">
                <span className="bg-gold-gradient rounded-full px-2.5 py-1 text-[11px] font-extrabold uppercase tracking-wide text-navy" data-id="element-24" data-mp="3idwofjt8hcl8">
                  {item.label}
                </span>
                <span className="rounded-full px-2.5 py-1 text-[11px] font-extrabold uppercase tracking-wide text-gold ring-1 ring-gold/50" data-id="element-25" data-mp="3r6i5mvh7vb7y">
                  {bonuses.includedLabel}
                </span>
              </div>
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gold/15 text-gold ring-1 ring-gold/40" data-id="element-26" data-mp="2zglrw6yzkx9h">
                <GiftIcon className="h-5 w-5" aria-hidden="true" data-id="element-27" data-mp="2uik9zpdar3zl" />
              </span>
            </div>
            <h3 className="mt-4 text-base font-extrabold uppercase leading-snug text-white sm:text-[17px]" data-id="element-28" data-mp="38e5x1qzyzdpd">
              {item.title}
            </h3>
            <p className="mt-2 font-bold leading-snug text-white" data-id="element-29" data-mp="nozyyrd6ka94">{item.subtitle}</p>
            <p className="mt-2 leading-relaxed text-white/80" data-id="element-30" data-mp="irgayzqokj3z">{item.text}</p>
            <VerbChips text={item.punchline} tone="dark" className="mt-4" data-id="element-31" data-mp="3ciwqenh6xfi3" />
          </Reveal>)}
      </ul>
    </Section>;
}